import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Link, type AnyRoute } from '@frontend/weave-router';
import { theme } from '@frontend/theme';
import { Accordion, TextLink } from '@frontend/design-system';
import { useSchedulePulseRequestList, useScheduleRequestNotificationsAsRead } from '../../hooks';
import { ScheduleRequestTray } from '../../ScheduleRequestModal/ScheduleRequestWrappers';
import { ScheduleRequestsTrackingIds } from '../../trackingIds';
import { ScheduleRequestListContent } from './../ScheduleRequestListContent';
import { SchedulePulseRequestListItem } from './SchedulePulseRequestListItem';

interface SchedulePulseRequestListProps {
  locationId: string;
  height?: number | string;
}

export const SchedulePulseRequestList = ({ locationId, height }: SchedulePulseRequestListProps) => {
  const { t } = useTranslation('scheduleCalendarActions');
  const { markNotificationsAsRead } = useScheduleRequestNotificationsAsRead();
  const { refetchScheduleRequestList, isEmptyScheduleRequestList, infiniteListQuery } = useSchedulePulseRequestList({
    locationId,
  });

  return (
    <>
      <Accordion
        css={{ ...(isEmptyScheduleRequestList && { background: theme.colors.white }), flexGrow: 1 }}
        variant='blank'
        chevronSize={16}
        startingValue=''
        size='large'
        onChange={(val) => {
          if (!!val) {
            markNotificationsAsRead(val);
          }
        }}
      >
        <ScheduleRequestListContent
          refetchScheduleRequestList={refetchScheduleRequestList}
          infiniteListQuery={infiniteListQuery}
          height={height}
          modalWrapper={ScheduleRequestTray}
          scheduleRequestListItem={SchedulePulseRequestListItem}
        />
      </Accordion>
      <div css={viewHistoryContainerStyles}>
        <TextLink
          as={Link}
          css={{ display: 'flex', alignItems: 'center' }}
          size='medium'
          weight='bold'
          to={`/schedule/request-history?locationId=${locationId}` as AnyRoute}
          trackingId={ScheduleRequestsTrackingIds.viewHistoryBtn}
        >
          <Icon name='external-link-small' css={{ marginRight: theme.spacing(0.5) }} />
          {t('View History')}
        </TextLink>
      </div>
    </>
  );
};

const viewHistoryContainerStyles = css({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(2),
  background: theme.colors.white,
  borderTop: `1px solid ${theme.colors.neutral10}`,
});
